'use client';

import { Activity, useState } from 'react';

import { getENV, useCacheKey, useOptimizely } from '@libs/common-next';

import { CacheKey } from './cache-key';
import { Flags } from './flags';
import { Fold } from './fold';
import { Preview } from './preview';
import { Tabs } from './tabs';

export function DevTools() {
    const { cookies } = useCacheKey();
    const { instance } = useOptimizely();
    const [tab, setTab] = useState('Feature flags');
    const debug = cookies.has('x-petm-devtools');
    const dataFile = JSON.parse(instance?.getOptimizelyConfig()?.getDatafile() ?? '{}');
    const active = (active: string) => (tab === active ? 'visible' : 'hidden');
    const { NEXT_PUBLIC_APP_ENV } = getENV();

    if (NEXT_PUBLIC_APP_ENV === 'prod' || !debug || !Object.keys(dataFile).length) return null;

    return (
        <Fold>
            <Tabs value={tab} onChange={setTab} />

            <Activity mode={active('Feature flags')}>
                <Flags dataFile={dataFile} />
            </Activity>
            <Activity mode={active('Cache Key')}>
                <CacheKey />
            </Activity>
            <Activity mode={active('Site Preview')}>
                <Preview />
            </Activity>
        </Fold>
    );
}
